export default __webpack_public_path__ + "static/media/IMG-473.f34fe217.svg";